import EventBus from "./eventBus";

const NETWORK_ERROR_NOTICE_INTERVAL = 10000;
let lastNoticeAt = 0;

export const isTimeoutError = (error) => {
  return !!(
    error &&
    (error.code === "ECONNABORTED" ||
      String(error.message || "")
        .toLowerCase()
        .includes("timeout"))
  );
};

export const notifyNetworkError = () => {
  const now = Date.now();
  if (now - lastNoticeAt < NETWORK_ERROR_NOTICE_INTERVAL) return;
  lastNoticeAt = now;
  EventBus.$emit("hide", {
    type: "error",
    msg: "Kết nối quá chậm. Vui lòng thử lại.",
  });
};



// WEBPACK FOOTER //
// ./src/utils/networkError.js